import { render, staticRenderFns } from "./SendQuoteCustomer.vue?vue&type=template&id=72e128a7&scoped=true&"
import script from "./SendQuoteCustomer.vue?vue&type=script&lang=js&"
export * from "./SendQuoteCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e128a7",
  null
  
)

export default component.exports